import React, { FunctionComponent } from 'react';
import { FormControl } from 'react-bootstrap';

import { WarningButton } from '@components/library/button';
import { StandardCheckbox } from '@components/library/checkbox';
import { UpdateRowArguments } from '@components/brandfolder/settings/custom-fields-tab/CustomFieldsForm';
import { DisplayedCustomFieldKey } from '@components/brandfolder/settings/custom-fields-tab/CustomFieldsTab';
import PillInput from '@components/common/pill_input/main';

interface CustomFieldRowProps {
  displayedCustomFieldKey: DisplayedCustomFieldKey;
  hasRolloutMultiValueCustomFieldsFeature: boolean;
  index: number;
  removeRow: (index: number) => void;
  updateRow: (updateRowObject: UpdateRowArguments) => void;
  valid: boolean;
}

interface PillState {
  active: boolean;
  newPill: string;
  pendingDelete: boolean;
  pills: string[];
}

export const CustomFieldRow: FunctionComponent<CustomFieldRowProps> = ({
  displayedCustomFieldKey,
  hasRolloutMultiValueCustomFieldsFeature,
  index,
  removeRow,
  updateRow,
  valid,
}) => {
  const {
    allowedValues: allowedValuesProp,
    multiValueEnabled: multiValueEnabledProp,
    multiValuePersisted,
    name: nameProp,
  } = displayedCustomFieldKey;

  const handleUpdateRow = ({ allowedValues, multiValueEnabled, name }: UpdateRowArguments): void => {
    updateRow({
      index,
      ...allowedValues !== undefined && { allowedValues },
      ...multiValueEnabled !== undefined && { multiValueEnabled },
      ...name !== undefined && { name },
    });
  };

  return (
    <div className="brandfolder-settings__control-custom-fields--list-item">
      <div className="custom-field-key-input column-1">
        <FormControl
          className="custom-field-input"
          id={nameProp}
          name="name"
          onChange={(e): void => handleUpdateRow({ name: e.target.value })}
          placeholder={bfTranslate("Key")}
          style={{ borderColor: !valid && nameProp !== "" && "#D0021B" }}
          type="text"
          value={nameProp}
        />
      </div>
      <div className="custom-field-values-input column-2">
        <PillInput
          className="custom-field-input"
          id="allowed_values"
          name="allowed_values"
          onChangeCallback={(pillState: PillState): void => handleUpdateRow({ allowedValues: pillState.pills })}
          pills={allowedValuesProp}
          placeholderText={allowedValuesProp.length === 0 && bfTranslate("Input value")}
          type="text"
        />
      </div>
      {hasRolloutMultiValueCustomFieldsFeature && (
        <StandardCheckbox
          ariaLabel={bfTranslate(`allow multiple values for custom field ${nameProp}`)}
          checked={multiValueEnabledProp}
          disabled={multiValuePersisted}
          className="allow-multiple-values-checkbox column-3"
          onChange={(): void => handleUpdateRow({ multiValueEnabled: !multiValueEnabledProp })}
        />
      )}
      <WarningButton
        aria-label={`remove ${nameProp}`}
        className="remove-control-custom-field column-4"
        icon="bff-trash"
        onClick={(): void => removeRow(index)}
      />
    </div>
  );
};
